const getUserData = (rootState) => rootState.user.userData;

export default getUserData;
